module.exports = __webpack_public_path__ + "static/media/BHARTIARTL_F1.6dc9cb73.txt";